import './Header.scss';

import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { type RefineThemedLayoutHeaderProps } from '@refinedev/antd';
import { Button, Flex, Layout as AntdLayout } from 'antd';
import React from 'react';

import { useUiContext } from '@/contexts/UiContext';
import { useUserContext } from '@/contexts/UserContext';

import CountrySelector from './CountrySelector';
import HeaderNotifications from './HeaderNotifications';
import UserMenuIcon from './UserMenuIcon';

const Header: React.FC<RefineThemedLayoutHeaderProps> = () => {
  const { openSider, setOpenSider, isMediumScreen } = useUiContext();
  const { userLogged, canChangeCountry } = useUserContext();

  return (
    <AntdLayout.Header className="LayoutHeader">
      {isMediumScreen && (
        <div className="LayoutHeaderMobileTrigger">
          <Button
            className="LayoutHeaderMobileTriggerButton"
            type="text"
            icon={openSider ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setOpenSider(!openSider)}
          />
        </div>
      )}
      <Flex gap={16} align="center" justify="end">
        {!isMediumScreen && canChangeCountry && <CountrySelector />}
        <HeaderNotifications />
        <UserMenuIcon user={userLogged} />
      </Flex>
    </AntdLayout.Header>
  );
};

export default Header;
